// Router.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from './App';
import PrivacyPolicy from './PrivacyPolicy';
import CookiesPolicy from './CookiesPolicy';
import TermsOfService from './TermsOfService';
import RefundPolicy from './RefundPolicy';
import ThankYouPage from './thank';

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/privacy_policy.php" element={<PrivacyPolicy />} />
      <Route path="/cookies_policy.php" element={<CookiesPolicy />} />
      <Route path="/terms_of_service.php" element={<TermsOfService />} />
      <Route path="/refund_policy.php" element={<RefundPolicy />} />
      <Route path="/thank.php" element={<ThankYouPage></ThankYouPage>} />
    </Routes>
  );
};

export default Router;
